import template from './voyo_volume.html';

class VoyoVolume extends HTMLElement {

    private button: HTMLButtonElement | null = null;
    private slider: HTMLInputElement | null = null;

    connectedCallback(): void {
        this.innerHTML = template;

        this.button = this.querySelector('.volume__button');
        this.slider = this.querySelector('.volume__slider');

        this.button?.addEventListener('click', this.onMuteClick);
        this.slider?.addEventListener('input', this.onSliderInput);
        this.slider?.addEventListener('change', this.onSliderChange);
    }

    disconnectedCallback(): void {
        this.button?.removeEventListener('click', this.onMuteClick);
        this.slider?.removeEventListener('input', this.onSliderInput);
        this.slider?.removeEventListener('change', this.onSliderChange);
    }

    setVolume(volume: number, muted: boolean = false): void {
        const volumeNorm = Math.max(0, Math.min(1, volume));
        const isMuted = muted || volumeNorm === 0;

        // The video keeps its volume while muted — muting is the flag, not a volume of 0.
        app.voyoVideo.setVideoVolume(volumeNorm, isMuted);

        this.render(isMuted ? 0 : volumeNorm);
    }

    private saveVolume(volume: number, muted: boolean = false): void {
        const volumeNorm = Math.max(0, Math.min(1, volume));
        const isMuted = muted || volumeNorm === 0;

        config.videoMuted = isMuted;

        // We do not want to save videoVolume as 0, thats what the videoMuted boolean is for
        if (!isMuted) {
            config.videoVolume = volumeNorm;
        }

        app.saveUserOptions();
    }

    private onMuteClick = (event: Event): void => {
        event.preventDefault();

        const muted = !config.videoMuted;
        const volume = muted ? 0 : config.videoVolume;

        this.setVolume(volume, muted);
        this.saveVolume(volume, muted);
    }

    // Input event triggers on every small change when dragging the slider left and right
    // and sets the volume value so we can hear the volume change on the video in real time.
    private onSliderInput = (event: Event): void => {
        const value = (event.target as HTMLInputElement).value;
        this.setVolume(+value);
    }

    // Change event triggers only when user lets go of the slider (meaning they decided on a volume)
    // and only at that point to we save the values, so we can set the same volume in next opened player or after unmute.
    private onSliderChange = (event: Event): void => {
        const value = (event.target as HTMLInputElement).value;
        this.saveVolume(+value);
    }

    private render(value: number): void {
        if (!this.slider) {
            return;
        }

        this.slider.value = value.toFixed(2);
        this.slider.style.setProperty('--volume-percent', `${value * 100}%`);

        if (value > 0) {
            app.html.show('.volume__icon');
            app.html.hide('.volume__icon-muted');
        } else {
            app.html.hide('.volume__icon');
            app.html.show('.volume__icon-muted');
        }
    }
}

export default VoyoVolume;
